module.exports = __webpack_public_path__ + "static/media/la.6b86f25a.svg";